var React = require('react');

function TrashDark (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#fff;}")),React.createElement("path",{"className":"a","d":"M137.5,282.4a25.75,25.75,0,0,1,51.5,0,25.73,25.73,0,0,1-7.6,18.2,26.09,26.09,0,0,1-18.2,7.6,25.73,25.73,0,0,1-18.2-7.6A26.25,26.25,0,0,1,137.5,282.4ZM211.1,367a36.77,36.77,0,1,1,36.8,36.8,36.88,36.88,0,0,1-26-10.8,37.31,37.31,0,0,1-10.8-26Zm0-220.8a36.87,36.87,0,1,1,10.8,26,37.31,37.31,0,0,1-10.8-26ZM89.7,37.7a36.8,36.8,0,0,1,73.6,0,36.77,36.77,0,0,1-62.8,26A36.88,36.88,0,0,1,89.7,37.7ZM292.3,496.6H106.9l-61-390.2L0,114.5,69.9,539.2H328.5l76.6-424.3L359.3,106Z","transform":"translate(0 -0.9)","key":1})]);
}

TrashDark.defaultProps = {"viewBox":"0 0 405.1 538.3"};

module.exports = TrashDark;

TrashDark.default = TrashDark;
